<template>
  <div class="pop-right" v-show="popShow">
      <div class="imgbox">
        <div class="xx" v-on:click="closePop">
          <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_168_1030)">
              <path class="bg" opacity="0.25" d="M17.9984 35.9967C27.9386 35.9967 35.9967 27.9386 35.9967 17.9984C35.9967 8.05814 27.9386 0 17.9984 0C8.05814 0 0 8.05814 0 17.9984C0 27.9386 8.05814 35.9967 17.9984 35.9967Z" fill="black"/>
              <path d="M26.6941 10.9707L25.0283 9.30493L9.30225 25.031L10.968 26.6968L26.6941 10.9707Z" fill="white"/>
              <path d="M25.0295 26.6943L26.6953 25.0286L10.9692 9.30249L9.30347 10.9683L25.0295 26.6943Z" fill="white"/>
            </g>
            <defs>
              <clipPath id="clip0_168_1030">
                <rect width="36" height="36" fill="white"/>
              </clipPath>
            </defs>
          </svg>
        </div>
        <a href="javascript:;" v-on:click="scrollTo('#rd-section-16')">
          <img class="pc" :src="require('@/assets/images/fixed-popup_0327.png')" >
          <img class="mb" :src="require('@/assets/images/fixed-popup_mobile_0327.png')" >

        </a>
      </div>
  </div>
  <section class="sharp_header">
    <div class="nav-container">
      <div class="sharp_header_logo">
        <a href="https://tw.sharp/">
          <img class="logo" src="https://tw.sharp/sites/default/files/styles/large/public/logo_sharp.png?itok=EhVcmlhj" alt="">
        </a>
      </div>
      <nav>
        <div class="nav-mobile">
          <a id="nav-toggle" v-bind:class="{'active':mbMenuShow}" href="javascript:;" v-on:click="openMbMenu"><span></span></a>
        </div>
        <ul class="nav-list" id="rd-mb-menu">
          <li v-on:click="scrollTo('#rd-section-2')">
            <a href="javascript:;">關於我們</a>
          </li>
          <li class="me-4 nav-border"> | </li>
          <li v-on:click="scrollTo('#rd-section-14')">
            <a href="javascript:;">產品介紹</a>
          </li>
          <li class="me-4 nav-border"> | </li>
          <li v-on:click="scrollTo('#rd-section-16')">
            <a href="javascript:;">最新好康</a>
          </li>
          <li class="me-4 nav-border"> | </li>
          <li v-on:click="scrollTo('#rd-section-17')">
            <a href="javascript:;">購買通路</a>
          </li>
        </ul>
      </nav>
    </div>
  </section>
  <section class="section-1-kvarea" id="rd-section-1">
    <div class="logo-slogan">
      <div class="logoarea rd-down-stagger">
        <img :src="require('@/assets/images/logo.svg')" >
      </div>
      <div class="txt-box rd-down-stagger">
        <h3>今日も、日本のいい空気と。</h3>
        <h2>享受日本的好空氣</h2>
      </div>
    </div>
    <div class="kvpr-area rd-down-stagger">
      <img :src="require('@/assets/images/headerimg.png')" >
    </div>

  </section>
  <section class="section-2-tenyear" id="rd-section-2">
    <div class="max-1080">
        <div class="title-pic rd-down-stagger">
          <img :src="require('@/assets/images/setitle1.png')" >
        </div>
        <div class="ntxtbox">
          <div class="leftbox">
            <img :src="require('@/assets/images/article-img.jpg')" >
          </div>
          <div class="right-txt">
            <h2><span>連續十年</span>日本媽媽育兒雜誌票選第一<br>
              深獲廣大新手父母們的喜愛</h2>
            <p>
              日本知名母嬰雜誌權威"TamaHiyo Akachan Goods" 每年都會針對全國2000 多名有０個月至1歲半的新手父母們進行網路問卷調查，在空氣淨化的類別中，夏普空氣清淨機已經連續十年蟬連第一名的寶座，足以證明夏普獨創搭載PCI 自動除菌離子技術的空氣清淨機在日本深受廣大新手父母們的喜愛以及信任，事實證明可有效抑制過敏原跟病菌，讓家中小寶貝可一天24 小時處在安心安全的環境中，減少過敏原的產生，新生兒家中必備夏普PCI 自動除菌離子空氣清淨機。
            </p>
          </div>
        </div>
        <div class="txt-area rd-down-stagger">
          <h2>空氣淨化的領導者<sup>＊</sup></h2>
          <p>
            日本家喻戶曉的夏普空氣淨化技術 - Plasmacluster 「自動除菌離子技術」<br>
            深耕空氣淨化領域，目前已被廣泛應用於日常生活中。
          </p>
        </div>
      <ul class="cir-item rd-down-stagger">
        <li>
          <img :src="require('@/assets/images/cirpic04.png')" >
          <p>居家生活</p>
        </li>
        <li>
          <img :src="require('@/assets/images/cirpic01.png')" >
          <p>交通運輸</p>
        </li>
        <li>
          <img :src="require('@/assets/images/cirpic02.png')" >
          <p>公共設施
            <span>( 幼兒園、學校 )</span>
          </p>
        </li>
        <li>
          <img :src="require('@/assets/images/cirpic03.png')" >
          <p>醫療衛生</p>
        </li>
      </ul>
      <div class="note rd-down-stagger">
        <span>＊</span> 資料來源：日本2023たまひよ赤ちゃんグッズ大賞，統計2062名父母讀者的調查結果 。 從2014~2023，連續10年空氣清淨機類別票選結果。<br>
      </div>
      <div class="video-box">
        <h3 class="video-title rd-down-stagger">你知道待在室內的空汙危害是戶外5倍<br>
          讓醫師教你如何打造理想室內環境
        </h3>
        <div class="video-area rd-down-stagger">
          <div class="video-frame">
            <iframe src="https://www.youtube.com/embed/XckEso89LsE" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
<!--            <img :src="require('@/assets/images/video-cover.jpg')" >-->
          </div>
<!--          <button class="play-btn">-->
<!--            <svg width="180" height="180" viewBox="0 0 180 180" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--              <g filter="url(#filter0_d_98_915)">-->
<!--                <path d="M163 90C163 130.317 130.317 163 90 163C49.6832 163 17 130.317 17 90C17 49.6832 49.6832 17 90 17C130.317 17 163 49.6832 163 90Z" stroke="white" stroke-width="4"/>-->
<!--                <path d="M127.5 90L71.25 122.476L71.25 57.524L127.5 90Z" fill="white"/>-->
<!--              </g>-->
<!--              <defs>-->
<!--                <filter id="filter0_d_98_915" x="0" y="0" width="180" height="180" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">-->
<!--                  <feFlood flood-opacity="0" result="BackgroundImageFix"/>-->
<!--                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>-->
<!--                  <feOffset/>-->
<!--                  <feGaussianBlur stdDeviation="7.5"/>-->
<!--                  <feComposite in2="hardAlpha" operator="out"/>-->
<!--                  <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"/>-->
<!--                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_98_915"/>-->
<!--                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_98_915" result="shape"/>-->
<!--                </filter>-->
<!--              </defs>-->
<!--            </svg>-->
<!--          </button>-->
        </div>
      </div>
    </div>
  </section>
  <section class="section-3-pic" id="rd-section-3">
    <div class="title rd-down-stagger">
      室內中充滿看不見的<br>有害物質
    </div>
    <img class="rd-fade" :src="require('@/assets/images/section-3-img.jpg')" >
  </section>
  <section class="section-4-video" id="rd-section-4">
    <div class="videobox" id="rd-section-4-1">
      <div class="title rd-down-stagger">
        空氣中除了有害物質外<br>
        還有看不見的病毒有害您的健康
      </div>
      <video autoplay="" class="video sec-mv-img-pc" loop="" muted="" playsinline="" style="">
        <source src="https://tw.sharp/sites/default/files/uploads_vendor/2021/2021pci/2021pci-mov.mp4">
      </video>
    </div>
    <div class="two-infbox" id="rd-section-4-2">
      <div class="item rd-down-stagger">
        <div class="centertxt">
          <h3>
            附著型病毒<br>
            引起的接觸感染
          </h3>
          <p>
            附著於物體表面的病毒<br>
            也可能經由間接接觸傳染
          </p>
        </div>
      </div>
      <div class="item rd-down-stagger">
        <div class="centertxt">
          <h3>
            浮游型病毒<br>
            引起飛沫感染
          </h3>
          <p>
            常經由飛沫傳染<br>
            尤其在空氣不流通的密閉空間中
          </p>
        </div>
      </div>
    </div>
  </section>
  <section class="section-5-green" id="rd-section-5">
    <div class="mask-green"></div>
    <div class="max-1080">
      <div class="txt-area rd-down-stagger">
        <h3>源自大自然的空氣淨化力</h3>
        <h2>PCI自動除菌離子淨化技術</h2>
      </div>
      <div class="center-pic">
        <div class="bg-bubble rd-down-stagger">
          <img :src="require('@/assets/images/ion-group.png')" >
        </div>
        <div class="logoarea rd-down-stagger">
          <img :src="require('@/assets/images/logo.svg')" >
        </div>
      </div>
      <div class="blurbox rd-down-stagger">
        夏普獨創「Plasmacluster自動除菌離子」技術開發靈感來自「白血球」在攻擊侵入人體的細菌、異物時，會釋放出H＋及O2-兩種正、負離子來主動對抗細菌，夏普應用此原理開發可同時產生正負離子的自動除菌離子技術。而美國研究發現，空氣中的有害物質亦帶有正電與負電，市面上只能產生負離子的清淨裝置，無法完全有效的消除細菌。
        <a href="https://tw.sharp/pci" target="_blank">(more…)</a>
      </div>
    </div>
  </section>
  <section class="section-6-blue" id="rd-section-6">
    <div class="max-1080">
      <div id="rd-section-6-1">
        <h2 class="w-title rd-down-stagger">
          PCI自動除菌離子<br>
          淨化3步驟還原好空氣
        </h2>
        <div class="picbox rd-down-stagger">
          <img :src="require('@/assets/images/blueimg1.png')" >
        </div>
        <ul class="step-area">
          <li class="rd-fade">
            <div class="line"></div>
            <div class="num">1</div>
            <div class="txt">
              <h3>釋放正負離子</h3>
              <p>
                採用電漿放電技術，產生與大自然相同的
                正負離子，然後釋放到空氣中。
              </p>
            </div>
          </li>
          <li class="rd-fade">
            <div class="line"></div>
            <div class="num">2</div>
            <div class="txt">
              <h3>破壞細菌結構</h3>
              <p>
                離子只有在接觸到黴菌孢子、細菌或病毒表面時，
                才會轉換成氫氧自由基，發揮氧化特性的強大功效。
                這些氫氧自由基會快速擷取細菌蛋白質表面的
                氫離子(H)，破壞細菌的蛋白質結構。
              </p>
            </div>
          </li>
          <li class="rd-fade">
            <div class="num">3</div>
            <div class="txt">
              <h3>還原好空氣</h3>
              <p>
                氫氧離子與氫離子（H） 結合後，會形成
                水分子 (H2O)，然後還原到空氣中。
              </p>
            </div>
          </li>
        </ul>
      </div>
      <div id="rd-section-6-2">
        <div class="liz-iconbox">
          <h3 class="rd-down-stagger">自動除菌離子實證效果<sup>＊</sup></h3>
          <ul class="icon-list rd-down-stagger">
            <li>
              <img :src="require('@/assets/images/section-6-icon-1.svg')" >
              <p>抑制病毒</p>
            </li>
            <li>
              <img :src="require('@/assets/images/section-6-icon-2.svg')" >
              <p>抑制病毒</p>
            </li>
            <li>
              <img :src="require('@/assets/images/section-6-icon-3.svg')" >
              <p>PM2.5</p>
            </li>
            <li>
              <img :src="require('@/assets/images/section-6-icon-4.svg')" >
              <p>抑制過敏原</p>
            </li>
            <li>
              <img :src="require('@/assets/images/section-6-icon-5.svg')" >
              <p>抑制黴菌</p>
            </li>
            <li>
              <img :src="require('@/assets/images/section-6-icon-6.svg')" >
              <p>抑制靜電、毛躁</p>
            </li>
            <li>
              <img :src="require('@/assets/images/section-6-icon-7.svg')" >
              <p>消除異味</p>
            </li>
            <li>
              <img :src="require('@/assets/images/section-6-icon-8.svg')" >
              <p>美肌保濕</p>
            </li>
            <li>
              <img :src="require('@/assets/images/section-6-icon-9.svg')" >
              <p>營造舒壓環境</p>
            </li>
          </ul>
        </div>
        <div class="moreinfbox rd-down-stagger">
          <div class="left-wbox">
            <div class="toptxt">
              <span>世界首次實證</span><br>
              獨家自動除菌離子技術<br>
              新型冠狀病毒<span>變異株</span>
            </div>
            <div class="bottomtxt">
              <img :src="require('@/assets/images/person99.svg')" >
            </div>
          </div>
          <div class="right-box">
            <h2>自動除菌離子有效抑制新型冠狀病毒</h2>
            <p>
              根據夏普在島根大學醫學部微生物學講座吉山裕規教授（日本病毒學會理事）、明海大學保健醫療學部渡部茂教授、及京都工藝纖維大學機械工學系山川勝史教授的監督下，最新研究發現，是世界首次驗證對變異株新冠狀病毒有效抑制。
            </p>
            <a href="https://tw.sharp/pci/pci-covid-19" target="_blank" class="btn-more">
              更多資訊
              <img :src="require('@/assets/images/searchicon.svg')" >
            </a>
          </div>
        </div>

        <a href="https://tw.sharp/PCI/The-Effectiveness-of-Plasmacluster" class="note-link rd-down-stagger">
          <span>＊</span> 了解更多自動除菌離子實證效果詳情
        </a>
      </div>
    </div>
  </section>
  <section class="section-7-airtable" id="rd-section-7">
    <div class="max-1080">
      <h2 class="rd-down-stagger">
        深入研究<br>
        台灣季節空污對策
      </h2>
      <p class="rd-down-stagger">
        SHARP 空氣清淨機，特別針對台灣四季不同的花粉、黴菌、浮游病毒及<br>
        PM2.5等空氣問題，提出全方位的對策。
      </p>
      <div class="table-img rd-down-stagger">
        <img :src="require('@/assets/images/section-7-table.jpg')" >
      </div>
    </div>
  </section>
  <section class="section-8-pic" id="rd-section-8">
    <div class="title rd-down-stagger">
      給摯愛最好的空氣品質<br>
      <span>自我居家環境守護 不只濾淨更主動除菌</span>
    </div>
    <div class="logo-mark rd-down-stagger">
      <img :src="require('@/assets/images/section8-icon.png')" >

    </div>
    <div class="bg rd-fade">
      <div class="bubble1 rd-big-bubble-1">
        <img :src="require('@/assets/images/bubble-1.png')" >
      </div>
      <div class="bubble2 rd-big-bubble-2">
        <img :src="require('@/assets/images/bubble-2.png')" >
      </div>
      <div class="bubble3 rd-big-bubble-3">
        <img :src="require('@/assets/images/bubble-3.png')" >
      </div>

      <div class="b-red-01 rd-bubble">
        <img :src="require('@/assets/images/ion-red.png')" >
      </div>
      <div class="b-red-02 rd-bubble">
        <img :src="require('@/assets/images/ion-red.png')" >
      </div>
      <div class="b-blu-01 rd-bubble">
        <img :src="require('@/assets/images/ion-blue.png')" >
      </div>
      <div class="b-red-03 rd-bubble">
        <img :src="require('@/assets/images/ion-red.png')" >
      </div>
      <div class="b-blu-02 rd-bubble">
        <img :src="require('@/assets/images/ion-blue.png')" >
      </div>
      <div class="b-blu-03 rd-bubble">
        <img :src="require('@/assets/images/ion-blue.png')" >
      </div>
      <div class="b-red-04 rd-bubble">
        <img :src="require('@/assets/images/ion-red.png')" >
      </div>
      <div class="b-red-05 rd-bubble">
        <img :src="require('@/assets/images/ion-red.png')" >
      </div>
      <div class="b-blu-04 rd-bubble">
        <img :src="require('@/assets/images/ion-blue.png')" >
      </div>
      <div class="b-blu-05 rd-bubble">
        <img :src="require('@/assets/images/ion-blue.png')" >
      </div>
      <div class="b-blu-06 rd-bubble">
        <img :src="require('@/assets/images/ion-blue.png')" >
      </div>
      <div class="b-red-06 rd-bubble">
        <img :src="require('@/assets/images/ion-red.png')" >
      </div>
      <div class="b-red-07 rd-bubble">
        <img :src="require('@/assets/images/ion-red.png')" >
      </div>
      <div class="b-red-08 rd-bubble">
        <img :src="require('@/assets/images/ion-red.png')" >
      </div>
      <img class="pc" :src="require('@/assets/images/section-8-img.jpg')" >
      <img class="mb" :src="require('@/assets/images/section-8-imgm.jpg')" >
    </div>
  </section>
  <section class="section-9-airicon" id="rd-section-9">
    <div class="max-1080">
      <h2 class="rd-down-stagger">主動解決你生活中的空氣困擾</h2>
      <ul class="cir-item">
        <li class="rd-down-stagger">
          <img :src="require('@/assets/images/s9pic1.png')" >
          <p>淨化異味</p>
        </li>
        <li class="rd-down-stagger">
          <img :src="require('@/assets/images/s9pic2.png')" >
          <p>抑制過敏原</p>
        </li>
        <li class="rd-down-stagger">
          <img :src="require('@/assets/images/s9pic3.png')" >
          <p>抑制黴菌
          </p>
        </li>
        <li class="rd-down-stagger">
          <img :src="require('@/assets/images/s9pic4.png')" >
          <p>抑制病毒</p>
        </li>
      </ul>
    </div>
  </section>
  <section class="section-10-seven" id="rd-section-10">
    <div class="max-1080">
      <h2 class="rd-down-stagger">
        7大自動感應偵測<br>
        可補捉PM2.5高達99.9%
      </h2>
      <ul class="seven-list rd-down-stagger">
        <li>
          <div class="iconbox">
            <img :src="require('@/assets/images/section-10-icon-1.svg')" >
          </div>
          <p>PM2.5</p>
        </li>
        <li>
          <div class="iconbox">
            <img :src="require('@/assets/images/section-10-icon-2.svg')" >
          </div>
          <p>灰塵</p>
        </li>
        <li>
          <div class="iconbox">
            <img :src="require('@/assets/images/section-10-icon-3.svg')" >
          </div>
          <p>異味</p>
        </li>
        <li>
          <div class="iconbox">
            <img :src="require('@/assets/images/section-10-icon-4.svg')" >
          </div>
          <p>濕度</p>
        </li>
        <li>
          <div class="iconbox">
            <img :src="require('@/assets/images/section-10-icon-5.svg')" >
          </div>
          <p>溫度</p>
        </li>
        <li>
          <div class="iconbox">
            <img :src="require('@/assets/images/section-10-icon-6.svg')" >
          </div>
          <p>人體</p>
        </li>
        <li>
          <div class="iconbox">
            <img :src="require('@/assets/images/section-10-icon-7.svg')" >
          </div>
          <p>亮度</p>
        </li>
      </ul>
      <div class="machine-introbox rd-down-stagger">
        <div class="left">
          <img :src="require('@/assets/images/machine-intro-1.jpg')" >
        </div>
        <div class="right">
          <img :src="require('@/assets/images/machine-intro-2.png')" >
        </div>
      </div>
      <div class="gold-note rd-down-stagger">
        <div class="top-inf">
          <div class="leftbox">
            <img :src="require('@/assets/images/s10-gold.jpeg')" >
          </div>
          <div class="rightbox">
            <ul>
              <li>PM2.5是2.5μm以下細懸浮微粒子的統稱。</li>
              <li>
                本空氣清淨機對於0.1μm以下懸浮微粒子無法去除。空氣中有害物質無法全部去除。
              </li>
              <li>
                測試條件在32平方米（約4坪）密閉空間內實測結果，非實際使用空間取得結果。

              </li>
            </ul>
          </div>
        </div>
        <div class="bottom-inf">
          <p>
            <strong>關於空氣清淨機的除塵和除臭能力</strong><br>
            無法去除香菸中的有害物質（如一氧化碳）。對於持續性散發味道（建材臭味、寵物散發味道等）的成分非100%去除。
          </p>
          <span>
            ※ 在香菸或燒烤等味道濃的使用環境下，可能在數周或數月後濾網會發出異味，需提早更換濾網。若在類似環境使用，建議搭配空氣循環設備使用。
          </span>
        </div>
      </div>
    </div>
  </section>
  <section class="section-11-tensgs" id="rd-section-11">
    <div class="max-1080">
      <h2 class="rd-down-stagger">
        不僅有主動淨化<br>
        搭載十年濾網安心濾淨守護
      </h2>
      <div class="center-imgbox rd-down-stagger">
        <img :src="require('@/assets/images/machine-structure.jpg')" >
      </div>
      <ul class="sq-infbox">
        <li class="rd-down-stagger">
          <div class="short-title">
            在吸塵口捕捉大顆粒灰塵
          </div>
          <div class="blue-title">
            抗菌‧防黴·灰塵<br>
            前置過濾網
          </div>
          <div class="pic-area">
            <img :src="require('@/assets/images/structure-1.png')" >
          </div>
        </li>
        <li class="rd-down-stagger">
          <div class="short-title">
            無機吸附材質去除頑固異味、降低有害氣體
          </div>
          <div class="blue-title">
            活性碳過濾網 / 高效<br>
            活性碳過濾網
          </div>
          <div class="pic-area">
            <img :src="require('@/assets/images/structure-2.png')" >
          </div>
        </li>
        <li class="rd-down-stagger">
          <div class="short-title">
            能有效捕捉99.7%以上0.3μm微小粒子
          </div>
          <div class="blue-title">
            抗菌‧防黴·灰塵<br>
            集塵HEPA過濾網
          </div>
          <div class="pic-area">
            <img :src="require('@/assets/images/structure-3.png')" >
          </div>
        </li>
      </ul>
      <div class="sqs-title rd-down-stagger">
        <img :src="require('@/assets/images/sgs-logo.svg')" >
        <h3>空氣品質多項功能認證<sup>＊</sup></h3>
      </div>
      <ul class="sgs-icon">
        <li class="rd-down-stagger">
          <img :src="require('@/assets/images/circle-point1.png')" >
        </li>
        <li class="rd-down-stagger">
          <img :src="require('@/assets/images/circle-point2.png')" >
        </li>
        <li class="rd-down-stagger">
          <img :src="require('@/assets/images/circle-point3.png')" >
        </li>
        <li class="rd-down-stagger">
          <img :src="require('@/assets/images/circle-point4.png')" >
        </li>
      </ul>
      <div class="note rd-down-stagger">
        <span>＊</span> SGS認證檢驗報告PX/2019/A016901 ~ PX/2019/A016904(KI-J101T-W) <br>
        <div class="fs_14">以上功能以KI-J101T-W為例</div>
      </div>
    </div>
  </section>
  <section class="section-12-cocoro" id="rd-section-12">
      <div class="max-1080">
        <div class="cocotitle rd-down-stagger">
          <img :src="require('@/assets/images/section-12-title-img.png')" >
        </div>
        <h2 class="rd-down-stagger">
          搭載雲端智慧管家<br>
          全面守護家中每個角落
        </h2>
        <div class="center-image rd-down-stagger">
          <img :src="require('@/assets/images/cocoro-floor-plan.png')" >
        </div>
        <ul class="cocoroli">
          <li class="rd-down-stagger">
            <h3>多人連線</h3>
            <p>家人一同守護室內空氣</p>
          </li>
          <li class="rd-down-stagger">
            <h3>遠端監控</h3>
            <p>輕鬆開關、定時、調整風量</p>
          </li>
          <li class="rd-down-stagger">
            <h3>空氣品質</h3>
            <p>輕鬆查看室內空氣品質狀態</p>
          </li>
        </ul>
        <a href="https://tw.sharp/aiot/cocoro-air/index.html" class="btn-more rd-down-stagger">
          查看服務 <img :src="require('@/assets/images/icon-arrow.svg')" >
        </a>
      </div>
  </section>
  <section class="section-13-experience" id="rd-section-13" >
    <div class="max-1080">
      <h2 class="rd-down-stagger">
        愛用者有感推薦 <br>
        日本夏普空氣清淨機心得
      </h2>
      <div class="cardbox rd-down-stagger">
        <div class="arrl swiper-button-prev" style="display:none;">
          <img :src="require('@/assets/images/arll.svg')" >
        </div>
        <div class="arrr swiper-button-next" style="display:none;">
          <img :src="require('@/assets/images/arrr.svg')" >
        </div>

        <div class="pc-show">
          <swiper
              :cssMode="true"
              :modules="modules"
              class="mySwiper"
          >
<!--            <template v-for="index in 1" :key="index">-->
              <swiper-slide class="item-list1" >
                <div class="item">

                <a href="https://angelala.tw/sharp-air-purifier/" target="_blank" class="pic-box">
                  <div class="img-area"></div>
                </a>
                <div class="title-lbox">
                  <div class="peo-title">美食好芃友</div>
                  <a class="a-linkto" href="https://angelala.tw/sharp-air-purifier/" target="_blank">
                    <img :src="require('@/assets/images/linkto.svg')" >
                  </a>
                </div>
                <div  class="p">住在工業城市高雄,覺得我們高雄空氣紫爆率蠻高
                  的~這幾年發現空氣清淨機的重要性,尤其是我們
                  家中多了一個小小孩後~<a
                    href="https://angelala.tw/sharp-air-purifier/" target="_blank">(more)</a> </div>
                </div>
                <div class="item">

                  <a href="https://mochislife.com/sharp-jh51/" target="_blank" class="pic-box">
                    <div class="img-area img02"></div>
                  </a>
                  <div class="title-lbox">
                    <div class="peo-title">小梅減肥後新生活</div>
                    <a class="a-linkto" href="https://mochislife.com/sharp-jh51/" target="_blank">
                      <img :src="require('@/assets/images/linkto.svg')" >
                    </a>
                  </div>
                  <div  class="p">SHARP水活力空氣清淨機是我目前用過高效能的清
                    淨機,但運轉聲音非常安靜的產品~<a
                      href="https://mochislife.com/sharp-jh51/" target="_blank">(more)</a> </div>
                </div>
                <div class="item">

                  <a href="https://nellydyu.tw/blog/post/sharp?fbclid=IwAR0uGDR_NVdgHaqDtyEnBzEgzl-FzLWOQVVTKVK2JaWM6DenEeWOt_d27JE" target="_blank" class="pic-box">
                    <div class="img-area img03"></div>
                  </a>
                  <div class="title-lbox">
                    <div class="peo-title">跟著尼力吃喝玩樂＆親子生活</div>
                    <a class="a-linkto" href="https://nellydyu.tw/blog/post/sharp?fbclid=IwAR0uGDR_NVdgHaqDtyEnBzEgzl-FzLWOQVVTKVK2JaWM6DenEeWOt_d27JE" target="_blank">
                      <img :src="require('@/assets/images/linkto.svg')" >
                    </a>
                  </div>
                  <div  class="p">高雄空氣品質相當不好，每次小孩打噴嚏或者揉眼睛
                    我就感受到今日外面空氣不太好，也會影響居家環境
                    看到有人推薦這台
                    <a
                      href="https://nellydyu.tw/blog/post/sharp?fbclid=IwAR0uGDR_NVdgHaqDtyEnBzEgzl-FzLWOQVVTKVK2JaWM6DenEeWOt_d27JE" target="_blank">(more)</a> </div>
                </div>
                <div class="item">

                  <a href="https://www.facebook.com/gary6711/posts/791093132373228" target="_blank" class="pic-box">
                    <div class="img-area img04"></div>
                  </a>
                  <div class="title-lbox">
                    <div class="peo-title">菜朝</div>
                    <a class="a-linkto" href="https://www.facebook.com/gary6711/posts/791093132373228" target="_blank">
                      <img :src="require('@/assets/images/linkto.svg')" >
                    </a>
                  </div>
                  <div  class="p">我覺得家裡真的人人必備一台空氣清淨機，有寵物、小孩更是需要過濾家中空氣，這樣長期下來絕對是利大於弊... <a
                      href="https://www.facebook.com/gary6711/posts/791093132373228" target="_blank">(more)</a> </div>
                </div>
                <div class="item">

                  <a href="https://joytwins.com/sharp/?fbclid=IwAR00hBGALokzDAniewyUDNA13PtA73zumd5jAbAlo2JVmH-q37an5Lxw850" target="_blank" class="pic-box">
                    <div class="img-area img05"></div>
                  </a>
                  <div class="title-lbox">
                    <div class="peo-title">Joy Lee</div>
                    <a class="a-linkto"  href="https://joytwins.com/sharp/?fbclid=IwAR00hBGALokzDAniewyUDNA13PtA73zumd5jAbAlo2JVmH-q37an5Lxw850" target="_blank">
                      <img :src="require('@/assets/images/linkto.svg')" >
                    </a>
                  </div>
                  <div  class="p">SHARP夏普空氣清淨機正是採用離子技術能有效
                    制新型冠狀病毒變異。光看到這個我就整個非常熱
                    愛!... <a
                      href="https://joytwins.com/sharp/?fbclid=IwAR00hBGALokzDAniewyUDNA13PtA73zumd5jAbAlo2JVmH-q37an5Lxw850" target="_blank">(more)</a> </div>
                </div>
                <div class="item">

                  <a href="https://www.facebook.com/CorgiCoffeeTime/posts/pfbid0B79EPMAYbhA9oz2hYoctNi8SDzxh14t15NXAh7YMBjRy8zYHCLcq6KvBHZSGsVQnl" target="_blank" class="pic-box">
                    <div class="img-area img06"></div>
                  </a>
                  <div class="title-lbox">
                    <div class="peo-title">柯基犬のCoffee Time</div>
                    <a class="a-linkto" href="https://www.facebook.com/CorgiCoffeeTime/posts/pfbid0B79EPMAYbhA9oz2hYoctNi8SDzxh14t15NXAh7YMBjRy8zYHCLcq6KvBHZSGsVQnl" target="_blank">
                      <img :src="require('@/assets/images/linkto.svg')" >
                    </a>
                  </div>
                  <div  class="p">日系家電第一首選夏普AloT智慧空氣清淨機,空氣乾
                    淨又涼快,連嘎逼都喜歡躺在旁邊睡覺呢~ <a
                      href="https://www.facebook.com/CorgiCoffeeTime/posts/pfbid0B79EPMAYbhA9oz2hYoctNi8SDzxh14t15NXAh7YMBjRy8zYHCLcq6KvBHZSGsVQnl" target="_blank">(more)</a> </div>
                </div>
                <div class="item">

                  <a href="https://zineblog.com.tw/blog/post/230301?fbclid=IwAR1IDK3NFXzwsCet6IksI68-JX02Ea-M9xPWscEeWJW8IrAhEFbUFAE4TyU" target="_blank" class="pic-box">
                    <div class="img-area img07"></div>
                  </a>
                  <div class="title-lbox">
                    <div class="peo-title">大口老師的走跳學堂</div>
                    <a class="a-linkto" href="https://zineblog.com.tw/blog/post/230301?fbclid=IwAR1IDK3NFXzwsCet6IksI68-JX02Ea-M9xPWscEeWJW8IrAhEFbUFAE4TyU" target="_blank">
                      <img :src="require('@/assets/images/linkto.svg')" >
                    </a>
                  </div>
                  <div  class="p">這台「夏普AloT智慧空氣清淨機」不僅跟我們家的客廳風格很合拍，而且還能主動除菌脫臭，功能可說是相當強大~~~~ <a
                      href="https://zineblog.com.tw/blog/post/230301?fbclid=IwAR1IDK3NFXzwsCet6IksI68-JX02Ea-M9xPWscEeWJW8IrAhEFbUFAE4TyU" target="_blank">(more)</a> </div>
                </div>

            </swiper-slide>
<!--            </template>-->

          </swiper>
        </div>
        <div class="mb-show">
          <swiper
              :cssMode="true"
              :mousewheel="true"
              :keyboard="true"
              :loop="true"
              :modules="modules"
              :navigation=" { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev'}"
              :pagination="mbPagination"
              class="mySwiper2"
          >
<!--            <template v-for="index in 1" :key="index">-->
              <swiper-slide class="item-list1">
                <div class="item">

                  <a href="https://angelala.tw/sharp-air-purifier/" target="_blank" class="pic-box">
                    <div class="img-area"></div>
                  </a>
                  <div class="title-lbox">
                    <div class="peo-title">美食好芃友</div>
                    <a class="a-linkto" href="https://angelala.tw/sharp-air-purifier/" target="_blank">
                      <img :src="require('@/assets/images/linkto.svg')" >
                    </a>
                  </div>
                  <div  class="p">住在工業城市高雄,覺得我們高雄空氣紫爆率蠻高
                    的~這幾年發現空氣清淨機的重要性,尤其是我們
                    家中多了一個小小孩後~<a
                        href="https://angelala.tw/sharp-air-purifier/" target="_blank">(more)</a> </div>
                </div>
                <div class="item">

                  <a href="https://mochislife.com/sharp-jh51/" target="_blank" class="pic-box">
                    <div class="img-area img02"></div>
                  </a>
                  <div class="title-lbox">
                    <div class="peo-title">小梅減肥後新生活</div>
                    <a class="a-linkto" href="https://mochislife.com/sharp-jh51/" target="_blank">
                      <img :src="require('@/assets/images/linkto.svg')" >
                    </a>
                  </div>
                  <div  class="p">SHARP水活力空氣清淨機是我目前用過高效能的清
                    淨機,但運轉聲音非常安靜的產品~<a
                        href="https://mochislife.com/sharp-jh51/" target="_blank">(more)</a> </div>
                </div>
                <div class="item">

                  <a href="https://nellydyu.tw/blog/post/sharp?fbclid=IwAR0uGDR_NVdgHaqDtyEnBzEgzl-FzLWOQVVTKVK2JaWM6DenEeWOt_d27JE" target="_blank" class="pic-box">
                    <div class="img-area img03"></div>
                  </a>
                  <div class="title-lbox">
                    <div class="peo-title">跟著尼力吃喝玩樂＆親子生活</div>
                    <a class="a-linkto" href="https://nellydyu.tw/blog/post/sharp?fbclid=IwAR0uGDR_NVdgHaqDtyEnBzEgzl-FzLWOQVVTKVK2JaWM6DenEeWOt_d27JE" target="_blank">
                      <img :src="require('@/assets/images/linkto.svg')" >
                    </a>
                  </div>
                  <div  class="p">高雄空氣品質相當不好，每次小孩打噴嚏或者揉眼睛
                    我就感受到今日外面空氣不太好，也會影響居家環境
                    看到有人推薦這台
                    <a
                        href="https://nellydyu.tw/blog/post/sharp?fbclid=IwAR0uGDR_NVdgHaqDtyEnBzEgzl-FzLWOQVVTKVK2JaWM6DenEeWOt_d27JE" target="_blank">(more)</a> </div>
                </div>
                <div class="item">

                  <a href="https://www.facebook.com/gary6711/posts/791093132373228" target="_blank" class="pic-box">
                    <div class="img-area img04"></div>
                  </a>
                  <div class="title-lbox">
                    <div class="peo-title">菜朝</div>
                    <a class="a-linkto" href="https://www.facebook.com/gary6711/posts/791093132373228" target="_blank">
                      <img :src="require('@/assets/images/linkto.svg')" >
                    </a>
                  </div>
                  <div  class="p">我覺得家裡真的人人必備一台空氣清淨機，有寵物、小孩更是需要過濾家中空氣，這樣長期下來絕對是利大於弊... <a
                      href="https://www.facebook.com/gary6711/posts/791093132373228" target="_blank">(more)</a> </div>
                </div>

              </swiper-slide>
              <swiper-slide class="item-list1">
                <div class="item">

                  <a href="https://joytwins.com/sharp/?fbclid=IwAR00hBGALokzDAniewyUDNA13PtA73zumd5jAbAlo2JVmH-q37an5Lxw850" target="_blank" class="pic-box">
                    <div class="img-area img05"></div>
                  </a>
                  <div class="title-lbox">
                    <div class="peo-title">Joy Lee</div>
                    <a class="a-linkto"  href="https://joytwins.com/sharp/?fbclid=IwAR00hBGALokzDAniewyUDNA13PtA73zumd5jAbAlo2JVmH-q37an5Lxw850" target="_blank">
                      <img :src="require('@/assets/images/linkto.svg')" >
                    </a>
                  </div>
                  <div  class="p">SHARP夏普空氣清淨機正是採用離子技術能有效
                    制新型冠狀病毒變異。光看到這個我就整個非常熱
                    愛!... <a
                        href="https://joytwins.com/sharp/?fbclid=IwAR00hBGALokzDAniewyUDNA13PtA73zumd5jAbAlo2JVmH-q37an5Lxw850" target="_blank">(more)</a> </div>
                </div>
                <div class="item">

                  <a href="https://www.facebook.com/CorgiCoffeeTime/posts/pfbid0B79EPMAYbhA9oz2hYoctNi8SDzxh14t15NXAh7YMBjRy8zYHCLcq6KvBHZSGsVQnl" target="_blank" class="pic-box">
                    <div class="img-area img06"></div>
                  </a>
                  <div class="title-lbox">
                    <div class="peo-title">柯基犬のCoffee Time</div>
                    <a class="a-linkto" href="https://www.facebook.com/CorgiCoffeeTime/posts/pfbid0B79EPMAYbhA9oz2hYoctNi8SDzxh14t15NXAh7YMBjRy8zYHCLcq6KvBHZSGsVQnl" target="_blank">
                      <img :src="require('@/assets/images/linkto.svg')" >
                    </a>
                  </div>
                  <div  class="p">日系家電第一首選夏普AloT智慧空氣清淨機,空氣乾
                    淨又涼快,連嘎逼都喜歡躺在旁邊睡覺呢~ <a
                        href="https://www.facebook.com/CorgiCoffeeTime/posts/pfbid0B79EPMAYbhA9oz2hYoctNi8SDzxh14t15NXAh7YMBjRy8zYHCLcq6KvBHZSGsVQnl" target="_blank">(more)</a> </div>
                </div>
                <div class="item">

                  <a href="https://zineblog.com.tw/blog/post/230301?fbclid=IwAR1IDK3NFXzwsCet6IksI68-JX02Ea-M9xPWscEeWJW8IrAhEFbUFAE4TyU" target="_blank" class="pic-box">
                    <div class="img-area img07"></div>
                  </a>
                  <div class="title-lbox">
                    <div class="peo-title">大口老師的走跳學堂</div>
                    <a class="a-linkto" href="https://zineblog.com.tw/blog/post/230301?fbclid=IwAR1IDK3NFXzwsCet6IksI68-JX02Ea-M9xPWscEeWJW8IrAhEFbUFAE4TyU" target="_blank">
                      <img :src="require('@/assets/images/linkto.svg')" >
                    </a>
                  </div>
                  <div  class="p">這台「夏普AloT智慧空氣清淨機」不僅跟我們家的客廳風格很合拍，而且還能主動除菌脫臭，功能可說是相當強大~~~~ <a
                      href="https://zineblog.com.tw/blog/post/230301?fbclid=IwAR1IDK3NFXzwsCet6IksI68-JX02Ea-M9xPWscEeWJW8IrAhEFbUFAE4TyU" target="_blank">(more)</a> </div>
                </div>

              </swiper-slide>
<!--            </template>-->

          </swiper>
        </div>
      </div>
      <div class="dott-area rd-down-stagger rd-pc-dot" style="display:none;">
<!--        <div class="dot now"></div>-->
<!--        <div class="dot"></div>-->
<!--        <div class="dot"></div>-->
      </div>
      <div class="dott-area rd-down-stagger rd-mb-dot mb-show">
<!--        <div class="dot now"></div>-->
<!--        <div class="dot"></div>-->
<!--        <div class="dot"></div>-->
      </div>

      <div class="note rd-down-stagger">
        ※ 愛用者個人感想不代表本商品之功能性
      </div>

    </div>

  </section>
  <section class="section-14-jpair" id="rd-section-14">
    <div class="max-1080">
        <div class="titie-img rd-down-stagger">
          <img :src="require('@/assets/images/section-14-title-img.png')" >
        </div>
        <h2 class="rd-down-stagger">
          日本原裝水活力<br>
          AIoT智慧空氣清淨機系列
        </h2>
        <div class="recomm-box-mb">
          <h3>大坪數推薦</h3>
          <p>讓全家聚在一起呼吸好空氣，適合放置客廳、兒童遊戲室等公共大空間</p>
        </div>
        <div class="pr-area">
          <div class="left-primg rd-down-stagger">
            <img :src="require('@/assets/images/KI-J101T-W.png')" >
          </div>
        <div class="right-txt rd-down-stagger">
          <div class="recomm-box">
            <h3>大坪數推薦</h3>
            <p>讓全家聚在一起呼吸好空氣，適合放置客廳、兒童遊戲室等公共大空間</p>
          </div>
          <div class="prinf">
            <div class="pr-name">
              KI-J101T-W
            </div>
            <div class="shortinf">
              適用坪數：約~23坪
              <ul>
                <li>十年安心濾網守護 <br>(HEPA/ 活性碳/ 水活力增強過濾網)
                </li>
                <li>PM2.5/ 細菌/ 甲醛濾除率 99.9%</li>
              </ul>
            </div>
            <div class="f50000">
              <img :src="require('@/assets/images/ion-50000.png')" >
            </div>
            <a href="https://tw.sharp/products/ki-j101t" target="_blank" class="linkto">
              產品介紹
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="section-15-prlist" id="rd-section-15">
    <div class="left-box">
      <div class="recomm-box rd-down-stagger">
        <h3>小宅空間推薦</h3>
        <p>
          每晚睡覺都安心好眠<br>
          適合放置臥室、書房等小坪數空間
        </p>
      </div>
    </div>
    <div class="right-box">
      <ul>
        <li class="rd-down-stagger">
          <div class="left-pr">
            <img :src="require('@/assets/images/KC-JH71T-W.png')" >
          </div>
          <div class="right-inf">
            <div class="name">KC-JH71T-W</div>
            <div class="txt-inf">
              適用坪數：約~16坪<br>
              <p>PM2.5/細菌/甲醛濾除率99.9%</p>

            </div>
            <div class="f7000">
              <img :src="require('@/assets/images/ion-7000.png')" >
            </div>
            <a target="_blank" href="https://tw.sharp/products/kc-jh71t-w" class="linkto">
              產品介紹
            </a>
          </div>
        </li>
        <li class="rd-down-stagger">
          <div class="left-pr">
            <img :src="require('@/assets/images/KC-JH71T-W.png')" >
          </div>
          <div class="right-inf">
            <div class="name">KC-JH61T-W</div>
            <div class="txt-inf">
              適用坪數：約~14坪<br>
              <p>PM2.5/細菌/甲醛濾除率99.9%</p>
            </div>
            <div class="f7000">
              <img :src="require('@/assets/images/ion-7000.png')" >
            </div>
            <a target="_blank" href="https://tw.sharp/products/kc-jh61t-w" class="linkto">
              產品介紹
            </a>
          </div>
        </li>
        <li class="rd-down-stagger">
          <div class="left-pr">
            <img :src="require('@/assets/images/KC-JH71T-W.png')" >
          </div>
          <div class="right-inf">
            <div class="name">KC-JH51T-W</div>
            <div class="txt-inf">
              適用坪數：約~12坪<br>
              <p>PM2.5/細菌/甲醛濾除率99.9%</p>
            </div>
            <div class="f7000">
              <img :src="require('@/assets/images/ion-7000.png')" >
            </div>
            <a target="_blank" href="https://tw.sharp/products/kc-jh51t-w" class="linkto">
              產品介紹
            </a>
          </div>
        </li>
      </ul>
    </div>
  </section>
  <section class="section-16-gift" id="rd-section-16">
    <div class="max-1080">
      <div class="title-img rd-down-stagger">
        <img :src="require('@/assets/images/section-16-title-img.png')" >
      </div>
      <h2>12月底前買指定空氣清淨機好禮大放送</h2>
      <div class="gift-box" style="display: none">
        <div class="item rd-down-stagger">
          <div class="top-tag">
            <img :src="require('@/assets/images/gmark1.png')" >
          </div>
          <div class="pic-area">
            <img :src="require('@/assets/images/FU-NC01-W.png')" >
          </div>
          <div class="name">
            圓柱空氣清淨機
          </div>
          <p>
            FU-NC01-W 市價 $<span>4,490</span>
          </p>
          <div class="tag-area">
            <div class="tag">
              指定型號
            </div>
            <p>KI-J101T-W</p>
          </div>
        </div>
        <div class="item rd-down-stagger">
          <div class="top-tag">
            <img :src="require('@/assets/images/gmark2.png')" >
          </div>
          <div class="pic-area">
            <img :src="require('@/assets/images/R-TT20SS(B).png')" >
          </div>
          <div class="name">
            日系美型微波爐
          </div>
          <p>
            R-TT20SS(B) 市價 $<span>2,990</span>
          </p>
          <div class="tag-area">
            <div class="tag">
              指定型號
            </div>
            <p>KC-JH71T-W、KC-JH61T-W、KC-JH51T-W</p>
          </div>
        </div>
      </div>
      <div class="gift-box_n">
        <div class="item rd-down-stagger">
          <div class="top-tag">
            <img :src="require('@/assets/images/gift-badge-1.png')" >
          </div>
          <div class="pic-area">
            <img :src="require('@/assets/images/gift-img.png')" >
          </div>
          <div class="name">
            指定空氣清淨機<br>
            登錄送1.6L精美日本富士琺瑯烤盤組<br>
            <span>(SP-HM16-R) (市價$1,680)</span>
          </div>
          <div class="tag-area">
            <div class="tag">
              指定型號
            </div>
            <p>KI-J101T-W、KC-P70T-W、KC-P80T-W、FP-J60T-W、FP-J80T-W</p>
          </div>
        </div>
      </div>
      <a href="https://tw.sharp/member_center/event" target="_blank" class="btn-more rd-down-stagger">
        活動詳情<img :src="require('@/assets/images/icon-arrow.svg')" >
      </a>
    </div>

  </section>
  <section class="section-17-wherebuy" id="rd-section-17">
      <div class="max-1080">
        <h3 class="rd-down-stagger">哪裡買的到?</h3>
        <div class="logo-list rd-down-stagger">
          <a href="#">
            <img :src="require('@/assets/images/buy-logo-1.jpg')" >
          </a>
          <a href="#">
            <img :src="require('@/assets/images/buy-logo-2.jpg')" >
          </a>
          <a href="#">
            <img :src="require('@/assets/images/buy-logo-3.jpg')" >
          </a>
          <a href="#">
            <img :src="require('@/assets/images/buy-logo-4.jpg')" >
          </a>
          <a href="#">
            <img :src="require('@/assets/images/buy-logo-5.jpg')" >
          </a>
          <a href="#">
            <img :src="require('@/assets/images/buy-logo-6.jpg')" >
          </a>
          <a href="#">
            <img :src="require('@/assets/images/buy-logo-7.jpg')" >
          </a>
          <a href="#">
            <img :src="require('@/assets/images/buy-logo-8.jpg')" >
          </a>
          <a href="#">
            <img :src="require('@/assets/images/buy-logo-9.jpg')" >
          </a>
        </div>
        <a href="https://tw.sharp/where-to-buy" target="_blank" class="btn-more rd-down-stagger">
          查詢更多銷售據點<img :src="require('@/assets/images/searchicon.svg')" >
        </a>
      </div>
  </section>
  <section class="sharp_footer">
    <div class="footer-container">
      <div class="footer-link w-50 m-w-100">
        <ul class="w-50  m-w-100">
          <li>
            <a href="http://www.sharp-world.com/">
              Global
            </a>
          </li>
          <li>
            <a href="http://www.sharp-world.com/corporate_profile">
              關於夏普
            </a>
          </li>
          <li>
            <a href="https://tw.sharp/news">
              品牌消息
            </a>
          </li>
          <li>
            <a href="https://tw.sharp/support/">
              顧客服務
            </a>
          </li>
        </ul>
        <ul class="w-50 m-w-100">
          <li>
            <a href="https://tw.sharp/where-to-buy/">
              合作通路
            </a>
          </li>
          <li>
            <a href="https://sharp.cocorolife.tw/">
              夏普商城
            </a>
          </li>
          <li>
            <a href="https://tw.sharp/newsletter/">
              最新型錄
            </a>
          </li>
          <li>
            <a href="https://tw.sharp/healsio/recipes/">
              食譜查詢
            </a>
          </li>
        </ul>
      </div>
      <div class="footer-link w-50 m-w-100">
        <p class="title">社群媒體</p>
        <div class="footer-wrapper">
          <div class="footer-wrapper-item w-50">
            <a href="https://www.facebook.com/SHARPTaiwan/">
              <img class="footer-wrapper-icon" src="https://tw.sharp/sites/default/files/styles/thumbnail/public/menu_icons/icon-facebook.png?itok=OovP4rea" alt="">
              <span>Facebook</span>
            </a>
          </div>
          <div class="footer-wrapper-item w-50">
            <a href="https://www.instagram.com/sharp_taiwan/">
              <img class="footer-wrapper-icon" src="https://tw.sharp/sites/default/files/styles/thumbnail/public/menu_icons/icon-instagram_0.png?itok=bPtbD11z" alt="">
              <span>Instagram</span>
            </a>
          </div>
          <div class="footer-wrapper-item w-50">
            <a href="https://line.me/R/ti/p/%40usj0194y">
              <img class="footer-wrapper-icon" src="https://tw.sharp/sites/default/files/styles/thumbnail/public/menu_icons/LINE_333.jpg?itok=M7i1E2vK" alt="">
              <span>LINE</span>
            </a>
          </div>
          <div class="footer-wrapper-item w-50">
            <a href="https://www.youtube.com/channel/UCFevHGPIv1FLoHiq4kXe7xA">
              <img class="footer-wrapper-icon" src="https://tw.sharp/sites/default/files/styles/thumbnail/public/menu_icons/icon-youtube_0.png?itok=Td4_FQhh" alt="">
              <span>YouTube</span>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-copyright">
      <div class="copyright-container">
        <ul>
          <li>
            <a href="https://tw.sharp/terms/service">服務條款</a>
          </li>
          <li>
            <a href="https://tw.sharp/terms/privacy">隱私權聲明</a>
          </li>
        </ul>
        <p>
          Copyright © 2022 SHARP All Rights Reserved.
        </p>
      </div>
    </div>
  </section>

</template>

<script>
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Pagination, Navigation } from 'swiper';
import 'swiper/css';

gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(ScrollToPlugin)

export default {
  name: 'IndexView',
  props: {
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {
    return {
      modules: [Pagination, Navigation],
      pagination: {
        el:".rd-pc-dot",
        clickable: true,
        bulletActiveClass:'now',
        renderBullet: function (index, className) {
          return '<span class="dot ' + className + '"></span>';
        },
      },
      mbPagination: {
        el:".rd-mb-dot",
        clickable: true,
        bulletActiveClass:'now',
        renderBullet: function (index, className) {
          return '<span class="dot ' + className + '"></span>';
        },
      },
    };
  },
  data: function () {
    return {
      popShow:false,
      buildAnimate:false,
      mbMenuShow:false
    }
  },
  created () {
  },
  mounted () {
    this.animate()
  },
  watch: {
  },
  methods: {
    closePop(){
      this.popShow = false;
    },
    openMbMenu(){
      this.mbMenuShow = !this.mbMenuShow

      if(this.mbMenuShow){
        document.getElementById('rd-mb-menu').style.display ='block'
      }else{
        document.getElementById('rd-mb-menu').style.display ='none'
      }
    },
    scrollTo(dom){
      gsap.to(window, {duration: 2, scrollTo: {y: dom, offsetY: 0}});
      this.mbMenuShow = false
      document.getElementById('rd-mb-menu').style.display ='none'
    },
    animate(){
      const _this = this
      ScrollTrigger.create({
        trigger: '#rd-section-1',
        start: 'top-=50% top',
        markers: false,
        onEnter: function () {
          const t1 = gsap.timeline({delay:.5})
          t1.to('#rd-section-1 .rd-down-stagger',{stagger:0.2, y:0, opacity:1, duration:1})
        }
      })
      ScrollTrigger.create({
        trigger: '#rd-section-2',
        start: 'top top+=50%',
        markers: false,
        onEnter: function () {
          const t1 = gsap.timeline({delay:.1})
          t1.to('#rd-section-2 .rd-down-stagger',{stagger:0.2, y:0, opacity:1, duration:1})
        }
      })
      ScrollTrigger.create({
        trigger: '#rd-section-3',
        start: 'top top+=50%',
        markers: false,
        onEnter: function () {
          const t1 = gsap.timeline({delay:.1})
          t1.to('#rd-section-3 .rd-fade',{opacity:1, duration:1})
            .to('#rd-section-3 .rd-down-stagger',{stagger:0.2, y:0, opacity:1, duration:1},'<.5')
        }
      })
      ScrollTrigger.create({
        trigger: '#rd-section-4-1',
        start: 'top top+=50%',
        markers: false,
        onEnter: function () {
          const t1 = gsap.timeline({delay:.1})
          t1.to('#rd-section-4-1 .rd-down-stagger',{stagger:0.2, y:0, opacity:1, duration:1})
        }
      })
      ScrollTrigger.create({
        trigger: '#rd-section-4-2',
        start: 'top top+=50%',
        markers: false,
        onEnter: function () {
          const t1 = gsap.timeline({delay:.1})
          t1.to('#rd-section-4-2 .rd-down-stagger',{stagger:0.2, y:0, opacity:1, duration:1})
        }
      })
      ScrollTrigger.create({
        trigger: '#rd-section-5',
        start: 'top top+=50%',
        markers: false,
        onEnter: function () {
          const t1 = gsap.timeline({delay:.1})
          t1.to('#rd-section-5 .rd-down-stagger',{stagger:0.2, y:0, opacity:1, duration:1})
        }
      })
      ScrollTrigger.create({
        trigger: '#rd-section-6-1',
        start: 'top top+=50%',
        markers: false,
        onEnter: function () {
          const t1 = gsap.timeline({delay:.1})
          t1.to('#rd-section-6-1 .rd-down-stagger',{stagger:0.2, y:0, opacity:1, duration:1})
            .to('#rd-section-6-1 .rd-fade',{stagger:0.2, opacity:1, duration:2},'<.5')
        }
      })
      ScrollTrigger.create({
        trigger: '#rd-section-6-2',
        start: 'top top+=50%',
        markers: false,
        onEnter: function () {
          const t1 = gsap.timeline({delay:.1})
          t1.to('#rd-section-6-2 .rd-down-stagger',{stagger:0.2, y:0, opacity:1, duration:1})
        }
      })
      ScrollTrigger.create({
        trigger: '#rd-section-7',
        start: 'top top+=50%',
        markers: false,
        onEnter: function () {
          const t1 = gsap.timeline({delay:.1})
          t1.to('#rd-section-7 .rd-down-stagger',{stagger:0.2, y:0, opacity:1, duration:1})
        }
      })
      ScrollTrigger.create({
        trigger: '#rd-section-8',
        start: 'top top+=50%',
        markers: false,
        onEnter: function () {
          const t1 = gsap.timeline({delay:.1})
          t1.to('#rd-section-8 .rd-fade',{opacity:1, duration:2})
            .to('#rd-section-8 .rd-down-stagger',{stagger:0.2, y:0, opacity:1, duration:1},'<.5')

          if(!_this.buildAnimate){
            _this.buildAnimate = true
            gsap.to('.rd-big-bubble-1',{y:35, duration:3, repeat:-1, yoyo:true})
            gsap.to('.rd-big-bubble-2',{y:-40, duration:3, repeat:-1, yoyo:true})
            gsap.to('.rd-big-bubble-3',{y:-35, duration:3, repeat:-1, yoyo:true})

            document.querySelectorAll('.rd-bubble').forEach(function (e) {
              let end = gsap.utils.random(3, 6);
              gsap.timeline({repeat:-1, yoyo:false})
                  .to(e,{opacity:1,  duration:end})
                  .to(e,{y:-50,  duration:end},'<')
                  .to(e,{y:-100, x:20,  duration:end},'<')
                  .to(e,{y:-150, x:0,  duration:end},'<')
                  .to(e,{y:-200, x:30, duration:end},'<')
                  .to(e,{opacity:0, duration:end},'-='+3)

            })
          }

        }
      })
      ScrollTrigger.create({
        trigger: '#rd-section-9',
        start: 'top top+=50%',
        markers: false,
        onEnter: function () {
          const t1 = gsap.timeline({delay:.1})
          t1.to('#rd-section-9 .rd-down-stagger',{stagger:0.2, y:0, opacity:1, duration:1})
        }
      })
      ScrollTrigger.create({
        trigger: '#rd-section-10',
        start: 'top top+=50%',
        markers: false,
        onEnter: function () {
          const t1 = gsap.timeline({delay:.1})
          t1.to('#rd-section-10 .rd-down-stagger',{stagger:0.2, y:0, opacity:1, duration:1})
        }
      })
      ScrollTrigger.create({
        trigger: '#rd-section-11',
        start: 'top top+=50%',
        markers: false,
        onEnter: function () {
          const t1 = gsap.timeline({delay:.1})
          t1.to('#rd-section-11 .rd-down-stagger',{stagger:0.2, y:0, opacity:1, duration:1})
        }
      })
      ScrollTrigger.create({
        trigger: '#rd-section-12',
        start: 'top top+=50%',
        markers: false,
        onEnter: function () {
          const t1 = gsap.timeline({delay:.1})
          t1.to('#rd-section-12 .rd-down-stagger',{stagger:0.2, y:0, opacity:1, duration:1})
        }
      })
      ScrollTrigger.create({
        trigger: '#rd-section-13',
        start: 'top top+=50%',
        markers: false,
        onEnter: function () {
          const t1 = gsap.timeline({delay:.1})
          t1.to('#rd-section-13 .rd-down-stagger',{stagger:0.2, y:0, opacity:1, duration:1})
        }
      })
      ScrollTrigger.create({
        trigger: '#rd-section-14',
        start: 'top top+=50%',
        markers: false,
        onEnter: function () {
          const t1 = gsap.timeline({delay:.1})
          t1.to('#rd-section-14 .rd-down-stagger',{stagger:0.2, y:0, opacity:1, duration:1})
        }
      })
      ScrollTrigger.create({
        trigger: '#rd-section-15',
        start: 'top top+=50%',
        markers: false,
        onEnter: function () {
          const t1 = gsap.timeline({delay:.1})
          t1.to('#rd-section-15 .rd-down-stagger',{stagger:0.2, y:0, opacity:1, duration:1})
        }
      })
      ScrollTrigger.create({
        trigger: '#rd-section-16',
        start: 'top top+=50%',
        markers: false,
        onEnter: function () {
          const t1 = gsap.timeline({delay:.1})
          t1.to('#rd-section-16 .rd-down-stagger',{stagger:0.2, y:0, opacity:1, duration:1})
        }
      })
      ScrollTrigger.create({
        trigger: '#rd-section-17',
        start: 'top top+=50%',
        markers: false,
        onEnter: function () {
          const t1 = gsap.timeline({delay:.1})
          t1.to('#rd-section-17 .rd-down-stagger',{stagger:0.2, y:0, opacity:1, duration:1})
        }
      })
    },
  }
}
</script>
